<template>
  <ul class="contacts-inline-list">
    <UserContactsItem
      v-for="(contact, idx) in contacts.items"
      @openContacts="openContacts"
      :contact="contact"
      :is-show-contacts="contacts.contactsAvailable"
      :is-disabled="!contacts.contactsAvailable"
      :key="contact.kind + idx"
      is-resume-card
    />
  </ul>
</template>

<script>
import UserContactsItem from 'src/components/users/UserContactsItem/UserContactsItem.vue';

export default {
  name: 'ContactsInlineList',
  components: { UserContactsItem },
  props: {
    contacts: {
      type: Object,
      required: true,
    },
  },
  emits: ['openContacts'],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    openContacts() {
      this.$emit('openContacts');
    },
  },
};
</script>